import styled from '@emotion/styled';

import COLOR from '../../../../../../../shared/constant/colorset';

import { DealProduct } from '../../../../../types';

import { addComma } from '../../../../../../../shared/services';
import { getSubPrice, PriceService } from '../../../../../../service/priceService';

import DealProductStepper from '../../../../../shared/DealProductStepper';
import useDealProduct from '../../../../../hooks/useDealProduct';
import DeleteButton from './DeleteButton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 11px 10px 11px 15px;
  font-size: 12px;
  border-left: 1px solid ${COLOR.bg};
  border-top: 1px solid ${COLOR.bg};
  border-right: 1px solid ${COLOR.bg};
  &:last-of-type {
    border-bottom: 1px solid ${COLOR.bg};
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

const NameWrapper = styled(Row)`
  align-items: flex-start;
`;

const SelectWrapper = styled(Row)`
  align-items: center;
  padding-top: 12px;
`;

const DealName = styled.span`
  line-height: 16px;
  width: 320px;
  color: ${COLOR.kurlyGray800};
  overflow-wrap: break-word;
`;

const ExpectedPointGuideText = styled(DealName)`
  font-size: 12px;
  color: ${COLOR.kurlyGray600};
  margin-top: 4px;
`;

const BasePrice = styled.span`
  margin-right: 4px;
  font-weight: normal;
  font-size: 12px;
  color: ${COLOR.kurlyGray400};
  text-decoration: line-through;
`;

const Price = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: ${COLOR.kurlyGray800};
  padding-right: 5px;
`;

interface Props {
  dealProduct: DealProduct;
  displayRemove?: boolean;
}

export default function CartOptionItem({ dealProduct, displayRemove = true }: Props) {
  const { name, retailPrice, basePrice, discountedPrice } = dealProduct;
  const { representativePrice, kurlyPrice, originalPrice } = new PriceService({
    retailPrice,
    basePrice,
    discountedPrice,
  });

  const subPrice = getSubPrice({ originalPrice, kurlyPrice });

  const displayExpectedPointGuide = !dealProduct.isExpectedPoint;

  const { deselect } = useDealProduct(dealProduct);

  return (
    <Container className="cart-option-item">
      <NameWrapper>
        <DealName>{name}</DealName>
        {displayRemove && <DeleteButton onClick={deselect} />}
      </NameWrapper>
      {displayExpectedPointGuide && <ExpectedPointGuideText>적립제외상품</ExpectedPointGuideText>}
      <SelectWrapper>
        <DealProductStepper dealProduct={dealProduct} />
        <div>
          {!!subPrice && <BasePrice>{addComma(subPrice)}원</BasePrice>}
          <Price>{addComma(representativePrice)}원</Price>
        </div>
      </SelectWrapper>
    </Container>
  );
}
